import React from 'react';

export const SvgBlueCircle = () => (
  <span>
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <circle opacity="0.2" cx={10} cy={10} r={10} fill="#1C86ED" />
      <circle cx={10} cy={10} r="7.5" fill="#1C86ED" />
    </svg>
  </span>
);

export default SvgBlueCircle;
